export default __webpack_public_path__ + "static/media/cancela.d6d9defe.png";